<div class="ag-set-filter" data-sui-popover-boundary>
  <sui-input
    [id]="uid + '-search'"
    [(ngModel)]="search"
    [placeholder]="'ag-set-filter.placeholder.search' | translate"
  ></sui-input>
  <div class="ag-set-filter__bulk">
    <sui-button size="xsm" variant="secondary" (click)="selectAllVisible()">
      {{ "ag-set-filter.button.select-all" | translate }}
    </sui-button>
    <sui-button size="xsm" variant="secondary" (click)="selectNoneVisible()">
      {{ "ag-set-filter.button.select-none" | translate }}
    </sui-button>
  </div>
  @if (blankEntries) {
    <div class="ag-set-filter__fixed" role="group">
      <sui-checkbox
        class="ag-set-filter__entry"
        [checked]="pendingBlank"
        (checkedChange)="toggleBlank($event)"
        >{{ "ag-set-filter.text.is-blank" | translate }}</sui-checkbox
      >
      <sui-checkbox
        class="ag-set-filter__entry"
        [checked]="pendingNotBlank"
        (checkedChange)="toggleNotBlank($event)"
        >{{ "ag-set-filter.text.is-not-blank" | translate }}</sui-checkbox
      >
    </div>
  }
  <div
    class="ag-set-filter__list"
    [class.ag-set-filter__list--muted]="pendingNotBlank"
    role="group"
  >
    @if (loading) {
      <span class="ag-set-filter__note">{{
        "ag-set-filter.text.loading" | translate
      }}</span>
    } @else if (visibleEntries.length === 0) {
      <span class="ag-set-filter__note">{{
        "ag-set-filter.text.no-matches" | translate
      }}</span>
    } @else {
      @for (entry of visibleEntries; track entry.key) {
        <sui-checkbox
          class="ag-set-filter__entry"
          [checked]="isSelected(entry)"
          (checkedChange)="toggle(entry, $event)"
          >{{ entry.label }}</sui-checkbox
        >
      }
    }
  </div>
  <div class="ag-set-filter__footer">
    <sui-button
      class="ag-set-filter__cancel"
      size="sm"
      variant="secondary"
      (click)="cancel()"
    >
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button size="sm" variant="secondary" (click)="reset()">
      {{ "ag-date-range-filter.button.reset" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!canApply"
      (click)="apply()"
    >
      {{ "btn.apply" | translate }}
    </sui-button>
  </div>
</div>
